import React from "react";

const ChatLoader = () => {
  return (
    <div className="col-md-7 col-lg-9">
        <div>
        <style>
            {`
            .loader {
            position: relative;
            display: flex;
            justify-content: center;
            margin-top: 30px;
            padding-left:200px
            }
            .loader:before, .loader:after {
            content: '';
            width: 5px;
            height: 5px;
            display: inline-block;
            position: relative;
            margin: 0 5px;
            border-radius: 50%;
            color: #658cc4ff;
            background: currentColor;
            box-shadow: 50px 0, -50px 0;
            animation: left 1s infinite ease-in-out;
            }
            .loader:after {
            color: #164ea2;
            animation: right 1.1s infinite ease-in-out;
            }

            @keyframes right {
            0%, 100% { transform: translateY(-10px); }
            50% { transform: translateY(10px); }
            }

            @keyframes left {
            0%, 100% { transform: translateY(10px); }
            50% { transform: translateY(-10px); }
            }
            `}
        </style>
        <span className="loader"></span>
        </div>
    </div>
  );
};

export default ChatLoader;
